<template>
  <!-- Minimal placeholder to satisfy imports; no visible UI by default -->
  <div class="network-status" />
  <!-- To show status, implement UI as needed -->
</template>

<script setup>
import { useNetworkStatus } from '@/composables/useNetworkStatus';
import { watch, onMounted, onUnmounted } from 'vue';

const { isOnline, hasLoginError, loginErrorMessage, clearLoginError, setupNetworkListeners, removeNetworkListeners } =
  useNetworkStatus();

// Emit event for retry login
const emit = defineEmits(['retry-login']);

const retryLogin = () => {
  emit('retry-login');
};

// Add/remove body class for spacing
const updateBodyClass = (offline) => {
  if (offline) {
    document.body.classList.add('network-status-active');
  } else {
    document.body.classList.remove('network-status-active');
  }
};

// Watch for network status changes
watch(
  [isOnline, hasLoginError],
  ([newOnline, newHasError]) => {
    updateBodyClass(!newOnline || newHasError);
  },
  { immediate: true },
);

// Register listeners when component mounts
onMounted(() => {
  setupNetworkListeners();
});

// Cleanup on unmount
onUnmounted(() => {
  removeNetworkListeners();
  document.body.classList.remove('network-status-active');
});
</script>

<style scoped>
.network-status {
  display: none;
}
</style>